import { render, staticRenderFns } from "./LogsPrincipal.vue?vue&type=template&id=00ef667a&"
import script from "./LogsPrincipal.vue?vue&type=script&lang=js&"
export * from "./LogsPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports